import { observer } from 'mobx-react-lite';
import { Bell } from 'lucide-react';
import { useStore } from '../../hooks/useStore';
import styles from './TopNavbar.module.css';

/**
 * Sidebar'ın yanında, içerik alanının üstünde - Bildirimler en sağda
 */
const TopNavbar = observer(() => {
  const { authStore, notificationStore } = useStore();

  return (
    <header className={styles.topNavbar}>
      <div className={styles.topNavbarContent}>
        <span className={styles.topNavbarUsername}>
          {authStore.username || authStore.user?.username || authStore.user?.userName || ''}
        </span>
        <button
          type="button"
          className={styles.topNavbarBell}
          onClick={notificationStore.openPopup}
          title="Bildirimler"
        >
          <Bell size={22} />
          {notificationStore.unreadCount > 0 && (
            <span className={styles.topNavbarBadge}>{notificationStore.unreadCount}</span>
          )}
        </button>
      </div>
    </header>
  );
});

export default TopNavbar;
